<div mat-dialog-title>
    <div>
        <div>
            <div class="dialog-title">Allow email notifications</div>
        </div>
    </div>
</div>
<div mat-dialog-content class="mt-16 mx-32">
    <div class="dialog-description">
        To receive reports from AdClairty, please enable "Allow email notifications" manually.
    </div>
    <img alt="" src="/assets/images/semrush/allow_notifications.png" height="134" width="320" />
</div>
<div mat-dialog-actions>
    <div class="action-buttons-wrapper">
        <button mat-button mat-flat-button class="mr-16 u-button h-32" color="accent" (click)="ok()">OK</button>
    </div>
</div>
